// const BASE_URL = "http://localhost:5000/";

// const BASE_URL = "http://162.19.146.135:1708/";

// const BASE_URL = "http://192.168.10.40:5000/node_api/";

const BASE_URL = "https://admin.yuri.infinitemlmsoft.com/node_api/";

// const BASE_URL = "https://admin.midasmeta.com/node_api/";

const DEFAULT_KEY = "8be61683-b0a2-47da-a81d-fd5a7a5227bb";

const PAYPAL_CLIENT_ID = "";

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID };
